/* @flow */
import Group from 'entities/Group';
import GroupHovercard from 'groups/components/GroupHovercard.jsx';
import HoverLayerTrigger from 'components/HoverLayerTrigger.jsx';
import Link from 'components/Link.jsx';
import React from 'react';

class GroupLink extends React.Component {
  static propTypes = {
    group: React.PropTypes.instanceOf(Group),
  };

  static defaultProps = {
    placement: 'right',
    alignment: 'middle',
  };

  render() {
    const { group, children, placement, alignment, ...other } = this.props;

    return (
      <HoverLayerTrigger
        layer={<GroupHovercard group={group} />}
        placement={placement}
        alignment={alignment}
        delayShow={200}>
        <Link
          to={group.webUrl()}
          activeClassName="active"
          {...other}>
          {children || group.getName()}
        </Link>
      </HoverLayerTrigger>
    );
  }
}

export default GroupLink;



// WEBPACK FOOTER //
// ./src/groups/components/GroupLink.jsx